import TheoreticalPartStudentListActionTypes from '../actions/theoretical-part-student-list-action-types';

const initialState = {
  loading: false,
  theoreticalPartStudents: null,
  theoreticalPartStudentsCancelToken: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TheoreticalPartStudentListActionTypes.LOAD_THEORETICAL_PART_STUDENT_LIST_START:
      return {
        ...state,
        loading: true
      };
    case TheoreticalPartStudentListActionTypes.LOAD_THEORETICAL_PART_STUDENT_LIST_END:
      return {
        ...state,
        theoreticalPartStudents: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
